import styled from "styled-components";

export const ListingDiv = styled.div.attrs({
  class: "flex",
})`
  flex-direction: column;
  flex: 1;
  width: 100%;
`;

export const List = styled.ul`
  flex: 1 0;
  flex-direction: column;
  padding: 10px;

  height: 100%;

  overflow-y: auto;

  .li {
    position: relative;
    background-color: #04aa6d;
    border: none;
    font-size: 28px;
    color: #ffffff;
    padding: 20px;
    width: 200px;
    text-align: center;
    transition-duration: 0.4s;
    text-decoration: none;
    overflow: hidden;
    cursor: pointer;
    border-radius: 8px;
  }
`;

export const ExcItem = styled.li<{ selected: boolean }>``;
